<template>
	<van-overlay class="subscribe_info_dialog subscribe_dialog" :show="visible">
		<div class="dialog_main subscribe_dialog__main">
			<div class="subscribe_dialog__main__body bg-white">
				<div class="header">
					<h2 class="title">{{ title }}</h2>
				</div>
				<div class="content">
					<div class="info">
						<p><span>患者姓名：</span>{{ info.patientName }}</p>
						<p><span>预约医生：</span>{{ info.doctorName }}</p>
						<p><span>预约时间：</span>{{ info.subscribeTime }}</p>
					</div>
					<p v-if="explain" class="explain text-center">{{ explain }}</p>
				</div>
				<div class="handle">
					<van-button v-if="type === 'preview'" type="primary" block round @click="visible = false">
						知道了
					</van-button>
					<van-button v-else type="primary" block round @click="clickConfirmSubscribe">确认预约</van-button>
				</div>
			</div>
			<div class="subscribe_dialog__main__close text-center">
				<img class="icon_close" src="@/assets/icon/icon_close_circle.png" @click="visible = false" />
			</div>
		</div>
	</van-overlay>
</template>

<script>
	export default {
		name: 'subscribe_info_dialog',
		props: {
			title: {
				type: String,
				default: '预约信息'
			},
			type: {
				type: String,
				default: ''
			},
			explain: {
				type: String,
				default: ''
			}
		},
		data: () => ({
			visible: false,
			info: {}
		}),
		methods: {
			init (info) {
				this.visible = true
				this.info = info
			},
			// 点击确认预约
			async clickConfirmSubscribe () {
				const res = await this.$api.physicianVisits.appointmentDoctor({
					patientId: this.info.patientId,
					scheduleId: this.info.scheduleId,
					orderSource: this.$store.getters['servicePack/getServiceChild'].orderSource,
					serviceDetailId: this.$store.getters['servicePack/getServiceChild'].id
				})
				if (!res.code) {
					await this.$router.push(`/physicianVisits/success/${res.data}`)
				} else if ([20020, 20021].includes(res.code)) {
					await this.$dialog.alert({
						title: '',
						message: res.msg,
						confirmButtonText: '知道了'
					})
				}
				this.visible = false
			}
		}
	};
</script>
